
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import { http } from "@/config/HttpClient";
import { AxiosResponse } from "axios";

@Component({
	name: "RxDocumentos",
})

export default class RxDocumentos extends Vue {
	@Prop() paciente_id!: any
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();

	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');
	historial = []
	file = []
	tratamiento_id = null
	descripcion = ''
	imagen = null;
	baseURLImage = `${process.env.VUE_APP_URL_BASE}`;
	mounted() {
		setTimeout(this.getDocumentos, 1500);
	}

	get tratamientos() {
		return this.consultorioStore.tratamientos;
	}
	get loading() {
		return this.consultorioStore.loading;
	}
	get documentos() {
		return this.consultorioStore.documentos;
	}

	async getDocumentos() {
		await http.get(`getDocumentos/${this.paciente_id}`).subscribe({
			next: (response: AxiosResponse) => {
				this.consultorioStore.documentos = response.data
				this.historial = response.data;
			},
		})
	}
	handleFileChange(file:any) {

		this.imagen = file;
		//console.log(event.target.files);
		// const files = event.target.files;
		console.log(this.imagen);

		// if (files && files.length > 0) {
		// 	const reader = new FileReader();
		// 	console.log(reader)
		// 	reader.onload = () => {
		// 		this.imageBase64 = reader.result as string;
		// 		console.log(this.imageBase64)
		// 	};
		// 	reader.readAsDataURL(files[0]);
		// }
	}
	uploadImage() {
		const formData = new FormData();
		formData.append('imagen', this.imagen);
		formData.append('paciente_id', this.paciente_id);
		// formData.append('cita_id', '1');
		formData.append('descripcion', this.descripcion);
		this.consultorioService.adjuntarDocumento(formData).then(res => {
			this.getDocumentos();

		});

	}




}

